import { ICONS, type IconName } from './icons';

export interface IconProps {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  /** Accessible label. Omit for decorative icons. */
  label?: string;
  className?: string;
  style?: React.CSSProperties;
}

/** React twin of Icon.astro for use inside islands. */
export function Icon({ name, size = 20, strokeWidth = 1.75, label, className, style }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={{ flex: 'none', display: 'inline-block', verticalAlign: 'middle', ...style }}
      aria-hidden={label ? undefined : true}
      role={label ? 'img' : undefined}
      aria-label={label}
      focusable="false"
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  );
}
export default Icon;
